import React, { useCallback, useContext, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import PreviewContext from '../contexts/PreviewContext';
import { ReactComponent as Close } from '../common/icons/close.svg';

const slideIn = keyframes`
  from {
    visibility: visible;
    transform: translateY(-70px);
    opacity: 0;
  }
  to {
    visibility: visible;
    transform: translateY(0);
    opacity: 1;
  }
`;

const PreviewBar = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  right: 0;
  left: 0;
  padding: 17px 16px;
  font-size: 14px;
  line-height: 16px;
  transition: 0.8s;
  animation: ${slideIn} 0.8s forwards;
  animation-delay: 0.3s;
  visibility: hidden;

  ${(props) =>
    props.variant === 'error'
      ? css`
          background: rgba(191, 7, 17, 0.7);
          color: #ffffff;
          a {
            color: #ffffff;
          }
          svg {
            fill: #ffffff;
          }
        `
      : css`
          background: rgba(255, 234, 138, 0.9);
          color: #595130;
        `}

  @media only screen and (max-device-width: 667px) {
    padding: 0;
  }
`;

const PreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
`;

const PreviewContent = styled.div`
  flex: 1;
  text-align: center;

  @media only screen and (max-device-width: 667px) {
    span.full {
      display: none;
    }
  }

  a {
    text-decoration: underline;
  }

  a:hover {
    opacity: 0.8;
  }
`;

const CloseButton = styled.button`
  flex: 0 0 auto;
  justify-content: flex-end;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  outline: 0;
  box-shadow: none;
  text-decoration: none;
  user-select: text;
  font-size: 14px;
  line-height: 0;
  padding: 10px 12px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.6);
  }

  @media only screen and (max-device-width: 667px) {
    padding: 7px 8px;
  }
`;

export default () => {
  const [isDismissed, setDismissed] = useState(false);
  const { isPreview, error } = useContext(PreviewContext);

  const handleDismiss = useCallback(() => {
    setDismissed(true);
  }, []);

  const PreviewMessage = error ? (
    <span>
      <b>Gift Box Preview Error:</b> {error} (
      <a
        href="https://intercom.help/digismoothie/en/articles/5054875-how-does-preview-mode-work#h_b40be35a51"
        target="_blank"
        rel="noopener noreferrer"
      >
        what now?
      </a>
      )
    </span>
  ) : (
    <>
      <span className="full">You are in </span>
      <span>
        Gift Box Preview Mode (
        <a
          href="https://intercom.help/digismoothie/en/articles/5054875-how-does-preview-mode-work"
          target="_blank"
          rel="noopener noreferrer"
        >
          how does it work?
        </a>
        )
      </span>
    </>
  );

  return isPreview && !isDismissed ? (
    <PreviewBar {...(error ? { variant: 'error' } : {})}>
      <PreviewWrapper>
        <PreviewContent>{PreviewMessage}</PreviewContent>
        <CloseButton onClick={handleDismiss}>
          <Close />
        </CloseButton>
      </PreviewWrapper>
    </PreviewBar>
  ) : null;
};
